import script from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectStaff.vue?vue&type=script&setup=true&lang=js"

import "./SelectStaff.vue?vue&type=style&index=0&id=0c852540&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c852540"]])

export default __exports__